import { Trash2 } from 'lucide-react';
import type { ResponseFieldRow as ResponseFieldRowModel, ResponseRowIssue } from './response-mapping';
import {
  removeResponseFieldLabel,
  RESPONSE_MAPPING_COPY,
  responseFieldNameLabel,
  responseFieldPathLabel,
} from './response-mapping-copy';
import { ResponseFieldCell } from './ResponseFieldCell';
import styles from './ResponseMapping.module.css';
import toolFormStyles from './ToolForm.module.css';

type RowIssue = Omit<ResponseRowIssue, 'index'>;

interface ResponseFieldRowProps {
  row: ResponseFieldRowModel;
  issue?: RowIssue;
  guidance?: string;
  /** Suggested paths from the sample response, offered as a datalist. */
  pathListId?: string;
  onUpdate: (patch: Partial<ResponseFieldRowModel>) => void;
  onRemove: () => void;
}

export const ResponseFieldRow = ({
  row,
  issue,
  guidance,
  pathListId,
  onUpdate,
  onRemove,
}: ResponseFieldRowProps) => {
  const rowLabel = row.name || RESPONSE_MAPPING_COPY.rowFallback;
  const nameIssue = issue?.field === 'name' ? issue : undefined;
  const pathIssue = issue?.field === 'path' ? issue : undefined;

  const nameLabel = responseFieldNameLabel(rowLabel);
  const pathLabel = responseFieldPathLabel(rowLabel);
  const removeLabel = removeResponseFieldLabel(rowLabel);

  return (
    <tr className={guidance ? styles.guidedRow : undefined}>
      <ResponseFieldCell
        label={nameLabel}
        value={row.name}
        placeholder={RESPONSE_MAPPING_COPY.namePlaceholder}
        issue={nameIssue}
        hint={guidance}
        onChange={value => onUpdate({ name: value })}
      />
      <ResponseFieldCell
        label={pathLabel}
        value={row.path}
        placeholder={RESPONSE_MAPPING_COPY.pathPlaceholder}
        list={pathListId}
        issue={pathIssue}
        onChange={value => onUpdate({ path: value })}
      />
      <td>
        <button
          type="button"
          onClick={onRemove}
          className={toolFormStyles.removeButton}
          aria-label={removeLabel}>
          <Trash2 className={styles.removeIcon} />
        </button>
      </td>
    </tr>
  );
};
